import type { CompanyListItem } from "@/models/company.model";
import { TextField } from "@spz/ui/components/textfield";
import type { Table } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

export const CompanyListSearchBar = ({
  table,
}: {
  table: Table<CompanyListItem>;
}) => {
  const { t } = useTranslation();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    table.setGlobalFilter(e.target.value || undefined);
  };

  const searchTerm = table.getState().globalFilter ?? "";

  return (
    <TextField
      placeholder={t("search_company_placeholder")}
      leftIcon="search"
      value={searchTerm}
      onChange={handleChange}
      className="text-gray-700"
    />
  );
};
